// Global cart add toast listener
// Requires toast.js and notifications enabled.
import { ThemeEvents } from "@theme/events";

(function () {
  let lastShownAt = 0;
  const THROTTLE_MS = 800; // prevent rapid duplicates

  /**
   * @param {string | number | undefined} productId
   */
  function resolveProductTitle(productId) {
    if (!productId) return null;
    // Cherche un élément titre courant sur la page produit
    const metaTitleEl = document.querySelector(
      "h1[data-product-title], h1.product-title",
    );
    if (metaTitleEl) return metaTitleEl.textContent?.trim() || null;
    // Essaye via carte produit correspondante
    const card = document.querySelector(
      `[data-product-id="${productId}"] .product-card__title, [data-product-id="${productId}"] .product-card-title`,
    );
    if (card) return card.textContent?.trim() || null;
    return null;
  }

  document.addEventListener(ThemeEvents.cartUpdate, (e) => {
    const evt = /** @type {CustomEvent} */ (e);
    console.debug("[cart-toast] cartUpdate event reçu", evt.detail);
    const now = Date.now();
    const detail = evt.detail && evt.detail.data ? evt.detail.data : {};
    console.debug("[cart-toast] detail data", detail);
    if (detail.didError) return;
    if (now - lastShownAt < THROTTLE_MS) return;

    // Only show this toast on explicit add-to-cart events
    const isAdd = detail.source === "product-form-component";
    if (!isAdd) return;

    const qty = detail.itemCount || 1;
    const title = resolveProductTitle(detail.productId);
    let msg;
    if (title) {
      msg =
        qty > 1 ? `${qty} × ${title} added to cart` : `${title} added to cart`;
    } else {
      msg = qty > 1 ? `${qty} items added to cart` : `Item added to cart`;
    }

    if (window.toast) {
      console.debug("[cart-toast] Affichage toast immédiat");
      window.toast.show(msg, { type: "success" });
      lastShownAt = now;
    } else {
      console.debug("[cart-toast] Toast manager non prêt, retry dans 300ms");
      setTimeout(() => {
        window.toast?.show(msg, { type: "success" });
      }, 300);
    }
  });
})();
